export default {
  getMainCampaign: (state) => state.mainCampaign,
  getMainCampaignIsError: (state) => state.status.isError,
  getMainCampaignError: (state) => state.status.error,
  getMainCampaignIsLoading: (state) => state.status.isLoading
};
